// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsCatalogsUsageResult = objectOf({
  limits: objectOf({
    catalogs: number,
    file_size: number,
    storage: number,
  }),
  plan: string,
  usage: objectOf({
    catalogs_storage: number,
  }),
});
